export const getIucnGetLevelTwoBiomeLegendValues = () => [
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.no_data',
    color: '#000000',
    class_value: 'no_data',
    gray_index: 0,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.t1_tropical_subtropical_forests',
    color: '#005d00',
    class_value: 't1_tropical_subtropical_forests',
    gray_index: 11,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.t2_temperate_boreal_forests_woodlands',
    color: '#004d00',
    class_value: 't2_temperate_boreal_forests_woodlands',
    gray_index: 12,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.t3_shrublands_shrubby_woodlands',
    color: '#808000',
    class_value: 't3_shrublands_shrubby_woodlands',
    gray_index: 13,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.t4_savannas_grasslands',
    color: '#bdb76b',
    class_value: 't4_savannas_grasslands',
    gray_index: 14,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.t5_deserts_xeric_shrublands',
    color: '#ffb701',
    class_value: 't5_deserts_xeric_shrublands',
    gray_index: 15,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.t6_polar_alpine',
    color: '#adc4c0',
    class_value: 't6_polar_alpine',
    gray_index: 16,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.t7_intensive_land_use_systems',
    color: '#cd853f',
    class_value: 't7_intensive_land_use_systems',
    gray_index: 17,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.f1_rivers_streams',
    color: '#00bfff',
    class_value: 'f1_rivers_streams',
    gray_index: 21,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.f2_lakes',
    color: '#0000ff',
    class_value: 'f2_lakes',
    gray_index: 22,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.f3_artificial_wetlands',
    color: '#1f78b4',
    class_value: 'f3_artificial_wetlands',
    gray_index: 23,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.m1_marine_biogenic_systems',
    color: '#4a90e2',
    class_value: 'm1_marine_biogenic_systems',
    gray_index: 31,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.m2_pelagic_ocean_waters',
    color: '#1d2951',
    class_value: 'm2_pelagic_ocean_waters',
    gray_index: 32,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.fm1_semi_confined_transitional_waters',
    color: '#858536',
    class_value: 'fm1_semi_confined_transitional_waters',
    gray_index: 41,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.tf1_palustrine_wetlands',
    color: '#2e8b57',
    class_value: 'tf1_palustrine_wetlands',
    gray_index: 51,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.mt1_shoreline_systems',
    color: '#7a8a99',
    class_value: 'mt1_shoreline_systems',
    gray_index: 61,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.mt2_coastal_dune_systems',
    color: '#fdf5b8',
    class_value: 'mt2_coastal_dune_systems',
    gray_index: 62,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.iucn_get.level_2_biome.mft1_brackish_tidal_systems',
    color: '#4a708b',
    class_value: 'mft1_brackish_tidal_systems',
    gray_index: 71,
  },
];

export const getIucnGetLevelThreeEFGLegendValues = () => [
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.no_data',
    color: '#000000',
    class_value: 'no_data',
    gray_index: 0,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t1_1_tropical_subtropical_lowland_rainforests',
    color: '#048045',
    class_value: 't1_1_tropical_subtropical_lowland_rainforests',
    gray_index: 111,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t1_2_tropical_subtropical_dry_forests_and_thickets',
    color: '#ac86c0',
    class_value: 't1_2_tropical_subtropical_dry_forests_and_thickets',
    gray_index: 112,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t1_3_tropical_subtropical_montane_rainforests',
    color: '#ffffff',
    class_value: 't1_3_tropical_subtropical_montane_rainforests',
    gray_index: 113,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t2_1_boreal_and_temperate_high_montane_forests_and_woodlands',
    color: '#bc0383',
    class_value: 't2_1_boreal_and_temperate_high_montane_forests_and_woodlands',
    gray_index: 121,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t2_2_deciduous_temperate_forests',
    color: '#965eed',
    class_value: 't2_2_deciduous_temperate_forests',
    gray_index: 122,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t2_3_oceanic_cool_temperate_rainforests',
    color: '#7d951f',
    class_value: 't2_3_oceanic_cool_temperate_rainforests',
    gray_index: 123,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t2_4_warm_temperate_laurophyll_forests',
    color: '#d98c15',
    class_value: 't2_4_warm_temperate_laurophyll_forests',
    gray_index: 124,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t2_5_temperate_pyric_humid_forests',
    color: '#f1abff',
    class_value: 't2_5_temperate_pyric_humid_forests',
    gray_index: 125,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t2_6_temperate_pyric_sclerophyll_forests_and_woodlands',
    color: '#be7214',
    class_value: 't2_6_temperate_pyric_sclerophyll_forests_and_woodlands',
    gray_index: 126,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t3_1_seasonally_dry_tropical_shrublands',
    color: '#b03750',
    class_value: 't3_1_seasonally_dry_tropical_shrublands',
    gray_index: 131,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t3_2_seasonally_dry_temperate_heath_and_shrublands',
    color: '#e74d19',
    class_value: 't3_2_seasonally_dry_temperate_heath_and_shrublands',
    gray_index: 132,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t3_3_cool_temperate_heathlands',
    color: '#696ec3',
    class_value: 't3_3_cool_temperate_heathlands',
    gray_index: 133,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t3_4_young_rocky_pavements_lava_flows_and_screes',
    color: '#fbb043',
    class_value: 't3_4_young_rocky_pavements_lava_flows_and_screes',
    gray_index: 134,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t4_1_trophic_savannas',
    color: '#5b06be',
    class_value: 't4_1_trophic_savannas',
    gray_index: 141,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t4_2_pyric_tussock_savannas',
    color: '#583d4f',
    class_value: 't4_2_pyric_tussock_savannas',
    gray_index: 142,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t4_3_hummock_savannas',
    color: '#edfc30',
    class_value: 't4_3_hummock_savannas',
    gray_index: 143,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t4_5_temperate_subhumid_grasslands',
    color: '#363f08',
    class_value: 't4_5_temperate_subhumid_grasslands',
    gray_index: 145,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t5_1_semi_desert_steppe',
    color: '#e6891c',
    class_value: 't5_1_semi_desert_steppe',
    gray_index: 151,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t5_2_succulent_or_thorny_deserts_and_semi_deserts',
    color: '#032bc5',
    class_value: 't5_2_succulent_or_thorny_deserts_and_semi_deserts',
    gray_index: 152,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t5_3_sclerophyll_hot_deserts_and_semi_deserts',
    color: '#8daed3',
    class_value: 't5_3_sclerophyll_hot_deserts_and_semi_deserts',
    gray_index: 153,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t5_4_cool_deserts_and_semi_deserts',
    color: '#b359cb',
    class_value: 't5_4_cool_deserts_and_semi_deserts',
    gray_index: 154,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t5_5_hyper_arid_deserts',
    color: '#8b5536',
    class_value: 't5_5_hyper_arid_deserts',
    gray_index: 155,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t6_1_ice_sheets_glaciers_and_perennial_snowfields',
    color: '#3d8857',
    class_value: 't6_1_ice_sheets_glaciers_and_perennial_snowfields',
    gray_index: 161,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t6_2_polar_alpine_cliffs_screes_outcrops_and_lava_flows',
    color: '#e87587',
    class_value: 't6_2_polar_alpine_cliffs_screes_outcrops_and_lava_flows',
    gray_index: 162,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t6_3_polar_tundra_and_deserts',
    color: '#8336b8',
    class_value: 't6_3_polar_tundra_and_deserts',
    gray_index: 163,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t7_1_annual_croplands',
    color: '#7d29a9',
    class_value: 't7_1_annual_croplands',
    gray_index: 171,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t7_2_sown_pastures_and_fields',
    color: '#566e14',
    class_value: 't7_2_sown_pastures_and_fields',
    gray_index: 172,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t7_3_plantations',
    color: '#f4bf4a',
    class_value: 't7_3_plantations',
    gray_index: 173,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t7_4_urban_and_industrial_ecosystems',
    color: '#fc2a94',
    class_value: 't7_4_urban_and_industrial_ecosystems',
    gray_index: 174,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.t7_5_derived_semi_natural_pastures_and_old_fields',
    color: '#0e6040',
    class_value: 't7_5_derived_semi_natural_pastures_and_old_fields',
    gray_index: 175,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f1_1_permanent_upland_streams',
    color: '#3f8ed0',
    class_value: 'f1_1_permanent_upland_streams',
    gray_index: 211,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f1_2_permanent_lowland_rivers',
    color: '#2878b8',
    class_value: 'f1_2_permanent_lowland_rivers',
    gray_index: 212,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f1_4_seasonal_upland_streams',
    color: '#65a9dc',
    class_value: 'f1_4_seasonal_upland_streams',
    gray_index: 214,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f1_5_seasonal_lowland_rivers',
    color: '#4c96cd',
    class_value: 'f1_5_seasonal_lowland_rivers',
    gray_index: 215,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f1_6_episodic_arid_rivers',
    color: '#b7a06a',
    class_value: 'f1_6_episodic_arid_rivers',
    gray_index: 216,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f1_7_large_lowland_rivers',
    color: '#17649e',
    class_value: 'f1_7_large_lowland_rivers',
    gray_index: 217,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f2_1_large_permanent_freshwater_lakes',
    color: '#5eb9ec',
    class_value: 'f2_1_large_permanent_freshwater_lakes',
    gray_index: 221,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f2_2_small_permanent_freshwater_lakes',
    color: '#89d0ef',
    class_value: 'f2_2_small_permanent_freshwater_lakes',
    gray_index: 222,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f2_3_seasonal_freshwater_lakes',
    color: '#b2fc44',
    class_value: 'f2_3_seasonal_freshwater_lakes',
    gray_index: 223,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f2_6_permanent_salt_and_soda_lakes',
    color: '#ad10a8',
    class_value: 'f2_6_permanent_salt_and_soda_lakes',
    gray_index: 226,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f2_7_ephemeral_salt_lakes',
    color: '#6a4210',
    class_value: 'f2_7_ephemeral_salt_lakes',
    gray_index: 227,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f3_1_large_reservoirs',
    color: '#cb3855',
    class_value: 'f3_1_large_reservoirs',
    gray_index: 231,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.f3_3_rice_paddies',
    color: '#c9b458',
    class_value: 'f3_3_rice_paddies',
    gray_index: 233,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.m1_1_seagrass_meadows',
    color: '#141076',
    class_value: 'm1_1_seagrass_meadows',
    gray_index: 311,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.m1_2_kelp_forests',
    color: '#663dbc',
    class_value: 'm1_2_kelp_forests',
    gray_index: 312,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.m1_3_photic_coral_reefs',
    color: '#850c23',
    class_value: 'm1_3_photic_coral_reefs',
    gray_index: 313,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.m1_6_subtidal_rocky_reefs',
    color: '#6f6a8f',
    class_value: 'm1_6_subtidal_rocky_reefs',
    gray_index: 316,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.m1_7_subtidal_sand_beds',
    color: '#d9c98c',
    class_value: 'm1_7_subtidal_sand_beds',
    gray_index: 317,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.m2_1_epipelagic_ocean_waters',
    color: '#354a2a',
    class_value: 'm2_1_epipelagic_ocean_waters',
    gray_index: 321,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.fm1_2_permanently_open_riverine_estuaries_and_bays',
    color: '#2f6f9f',
    class_value: 'fm1_2_permanently_open_riverine_estuaries_and_bays',
    gray_index: 412,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.fm1_3_intermittently_closed_and_open_lakes_and_lagoons',
    color: '#858536',
    class_value: 'fm1_3_intermittently_closed_and_open_lakes_and_lagoons',
    gray_index: 413,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.tf1_1_tropical_flooded_forests_and_peat_forests',
    color: '#e0b4cc',
    class_value: 'tf1_1_tropical_flooded_forests_and_peat_forests',
    gray_index: 511,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.tf1_2_subtropical_temperate_forested_wetlands',
    color: '#5aabbc',
    class_value: 'tf1_2_subtropical_temperate_forested_wetlands',
    gray_index: 512,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.tf1_3_permanent_marshes',
    color: '#63f039',
    class_value: 'tf1_3_permanent_marshes',
    gray_index: 513,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.tf1_4_seasonal_floodplain_marshes',
    color: '#ec6bdb',
    class_value: 'tf1_4_seasonal_floodplain_marshes',
    gray_index: 514,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.tf1_6_boreal_temperate_and_montane_peat_bogs',
    color: '#00b9f4',
    class_value: 'tf1_6_boreal_temperate_and_montane_peat_bogs',
    gray_index: 516,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.tf1_7_boreal_and_temperate_fens',
    color: '#77d71d',
    class_value: 'tf1_7_boreal_and_temperate_fens',
    gray_index: 517,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.mt1_1_rocky_shorelines',
    color: '#1b96de',
    class_value: 'mt1_1_rocky_shorelines',
    gray_index: 611,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.mt1_2_muddy_shorelines',
    color: '#ea9e91',
    class_value: 'mt1_2_muddy_shorelines',
    gray_index: 612,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.mt1_3_sandy_shorelines',
    color: '#0c9494',
    class_value: 'mt1_3_sandy_shorelines',
    gray_index: 613,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.mt1_4_boulder_and_cobble_shores',
    color: '#436836',
    class_value: 'mt1_4_boulder_and_cobble_shores',
    gray_index: 614,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.mt2_1_coastal_shrublands_and_grasslands',
    color: '#3478ff',
    class_value: 'mt2_1_coastal_shrublands_and_grasslands',
    gray_index: 621,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.mft1_2_intertidal_forests_and_shrublands',
    color: '#22aeda',
    class_value: 'mft1_2_intertidal_forests_and_shrublands',
    gray_index: 712,
  },
  {
    text: 'shared.ncaDetail.ecosystemClassification.iucn_get.classification.level_3_efg.mft1_3_coastal_saltmarshes_and_reedbeds',
    color: '#f0ae6e',
    class_value: 'mft1_3_coastal_saltmarshes_and_reedbeds',
    gray_index: 713,
  },
];
